<template>

    <div class="route-login">

        <div class="content">
            <div class="content-holder">

                <div class="logos-holder">
                    <div class="logo">
                        <i class="img logo-aveco-color-180"></i>
                    </div>
                </div>

                <h1>Wachtwoord (opnieuw) instellen</h1>
                <span class="subtitle">Voer hieronder je gewenste wachtwoord in</span>

                <form @submit.prevent="submit">

                    <cms-input type="password" name="password" placeholder="Nieuw wachtwoord" v-model="password"
                               v-validate="'required'" data-vv-as="Nieuw wachtwoord" :error="error('password')"></cms-input>

                    <cms-input type="password" name="password" placeholder="Nieuw wachtwoord herhalen" v-model="passwordRepeat"
                               v-validate="'required'" data-vv-as="Herhaalde wachtwoord" :error="error('password')"></cms-input>

                    <cms-button :loading="submitting" @click="submit">Inloggen</cms-button>
                    <input type="submit" style="display: none" />
                </form>

            </div>
        </div>

        <toast-container></toast-container>

    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'vue'

    import validationMixin from '@wittignl/js-core/mixins/validation'

    import UserPasswordRequestMutations from "app/mutations/UserPasswordRequestMutations";
    import getGraphQLError from 'app/utils/getGraphQLError';
    import ApiError from 'app/enums/ApiError';

    @Component({

        name: 'ResetPassword',
        mixins: [validationMixin]
    })
    export default class ResetPassword extends Vue
    {
        submitting = false;

        password = null;
        passwordRepeat = null;

        mounted(){

            this.logger = this.$di.logger.child('ResetPassword');
            this.logger.info('Mounted');
        }

        async submit(){

            this.submitted = true;

            const success = await this.$validator.validateAll();
            if (!success) {

                this.$toast.warning('Niet alle velden zijn correct ingevuld');
                return;
            }

            if(this.password !== this.passwordRepeat){

                this.$toast.warning('Het herhaalde wachtwoord komt niet overeen');
                return;
            }

            this.submitting = true;

            try {

                await UserPasswordRequestMutations.resetPassword({
                    token: this.token,
                    password: this.password
                });

                this.$toast.success('Je wachtwoord is gewijzigd, je kunt nu inloggen met je nieuwe wachtwoord');
                this.$router.replace({ name: 'login' });
            }
            catch(e){

                const errorCode = getGraphQLError(e);
                const errorInfo = errorCode ? e.graphQLErrors[0].userInfo : null;

                this.logger.error(`Error resetting password (${errorCode})`, e);

                if(errorCode === ApiError.DATA_NOT_FOUND){
                    this.$toast.error('De link die je hebt gebruikt is niet (meer) geldig');
                }
                else if (errorCode === ApiError.PASSWORD_SHORT) {
                    this.$toast.error(`Het wachtwoord dient uit minimaal ${errorInfo.minLength} tekens te bestaan`);
                }
                else if (errorCode === ApiError.PASSWORD_WEAK) {
                    this.$toast.error(`Het gekozen wachtwoord is te zwak, gebruik minimaal 1 kleine letter, 1 hoofdletter en 1 cijfer en/of leesteken`);
                }
                else if (errorCode === ApiError.PASSWORD_NOT_UNIQUE) {
                    this.$toast.error(`Het gekozen wachtwoord is recentelijk al gebruikt, verzin een nieuw wachtwoord`);
                }
                else {
                    this.$toast.error('Het wachtwoord kon niet worden opgeslagen');
                }
            }

            this.submitting = false;
        }

        get token(){

            return this.$route.query.token;
        }
    }

</script>
